import {memo} from 'react';
import LinesEllipsis from 'react-lines-ellipsis';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';

export const ResponsiveEllipsisComponent = memo(responsiveHOC()(LinesEllipsis));
